
<div class="login-page" [ngClass]="loginUi.pageClass" [ngStyle]="loginPageStyles">
  <div class="container h-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center w-100">
      <div class="col-lg-8 col-xl-7">
        <div class="login-card row g-0 bg-white">
          <!-- Logo Section -->
          <div
            class="col-md-5 d-none d-md-flex align-items-center justify-content-center logo-section"
          >
            <img
              class="img-fluid"
              [src]="loginUi.logoPath"
              [alt]="loginUi.brandName + ' Logo'"
            />
          </div>

          <!-- Form Section -->
          <div class="col-md-7 p-4 p-md-5 d-flex flex-column justify-content-center">
            <mat-card class="border-0 bg-transparent">
              <form
                class="login-form"
                [formGroup]="loginForm"
                (ngSubmit)="onSubmit()"
                autocomplete="off"
              >
                <div class="text-center mb-4">
                  <h2 class="fw-bold mb-1" [style.color]="loginUi.titleColor">{{ loginUi.welcomeTitle }} 👋</h2>
                  <p class="small mb-0" [style.color]="loginUi.subtitleColor">{{ loginUi.brandName }}</p>
                 
                </div>

                <!-- Custom email field -->
                <div class="mb-3">
                  <div
                    class="custom-input-group"
                    [ngClass]="{
                      'has-error':
                        loginForm.controls['username'].invalid &&
                        (loginForm.controls['username'].dirty ||
                          loginForm.controls['username'].touched)
                    }"
                  >
                    <label class="custom-label mb-1">Username</label>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control custom-input pe-5"
                        formControlName="username"
                        placeholder="Enter your username"
                      />
                      <span class="input-icon text-muted">
                        <i class="bi bi-envelope"></i>
                      </span>
                    </div>
                  </div>
                  <div
                    class="text-danger small mt-1"
                    *ngIf="
                      loginForm.controls['username'].invalid &&
                      (loginForm.controls['username'].dirty ||
                        loginForm.controls['username'].touched)
                    "
                  >
                    <span *ngIf="loginForm.controls['username'].hasError('required')">
                      Username is required
                    </span>
                    <span
                      *ngIf="
                        !loginForm.controls['username'].hasError('required') &&
                        loginForm.controls['username'].hasError('email')
                      "
                    >
                      Please enter a valid email
                    </span>
                  </div>
                </div>

                <!-- Custom password field -->
                <div class="mb-2">
                  <div
                    class="custom-input-group"
                    [ngClass]="{
                      'has-error':
                        loginForm.controls['password'].invalid &&
                        (loginForm.controls['password'].dirty ||
                          loginForm.controls['password'].touched)
                    }"
                  >
                    <label class="custom-label mb-1">Password</label>
                    <div class="position-relative">
                      <input
                        [type]="showPassword ? 'text' : 'password'"
                        class="form-control custom-input"
                        [class.pe-5]="!showPassword"
                        [class.pe-4]="showPassword"
                        formControlName="password"
                        placeholder="Enter your password"
                      />
                      <button
                        type="button"
                        class="btn btn-link password-toggle"
                        (click)="togglePasswordVisibility()"
                        tabindex="-1"
                        aria-label="Toggle password visibility"
                      >
                        <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div
                    class="text-danger small mt-1"
                    *ngIf="
                      loginForm.controls['password'].invalid &&
                      (loginForm.controls['password'].dirty ||
                        loginForm.controls['password'].touched)
                    "
                  >
                    <span *ngIf="loginForm.controls['password'].hasError('required')">
                      Password is required
                    </span>
                    <span
                      *ngIf="
                        !loginForm.controls['password'].hasError('required') &&
                        loginForm.controls['password'].hasError('minlength')
                      "
                    >
                      Minimum 8 characters required
                    </span>
                  </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-3">
                 
                  <a
                    routerLink="/forgot-password"
                    class="text-decoration-none small fw-semibold link-primary"
                  >
                    Forgot password?
                  </a>
                </div>

                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="loading || loginForm.invalid"
                  class="w-100 fw-semibold login-btn"
                  type="submit"
                >
                  Login
                </button>

                <mat-progress-bar
                  *ngIf="loading"
                  mode="indeterminate"
                  class="mt-3"
                ></mat-progress-bar>

             
              </form>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
